const YOUTUBE = 'youtube'
const HOSTED = 'hosted'

module.exports = {
  YOUTUBE,
  HOSTED,
}
